export default "__VITE_ASSET__D$PNOt5R__"